import {ClipboardEvent} from 'react';

export const pasteAsText = (event: ClipboardEvent<any>) => {
    // Prevent the default paste action
    event.preventDefault();

    // Get the clipboard data

    const text = event.clipboardData.getData('text/plain');

    // although deprecated this preserves the undo ctrl+z behaviour compared to insertTextAtCursor(text);
    document.execCommand("insertText", false, text);
}

const insertTextAtCursor = (text: string) => {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    range.deleteContents(); // Delete any selected text

    const textNode = document.createTextNode(text);
    range.insertNode(textNode);

    // Move the cursor to the end of the inserted text
    range.setStartAfter(textNode);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
}
